<template>
    <!-- :style=" showDome ? 'min-height: 165px;' : 'height: 165px;'" -->
    <div class="mdoleDome-box" style="min-height: 165px;">
        <div class="mdoleDome">
            <template v-if="goodsSkuDetail.join_coupon>0">
                <dl class="mdoleDome-top" v-if="couponList.length > 0">
                    <dt>优惠券</dt>
                    <div class="show-box" :style="isdiscounts ? 'min-height: 30px;' : 'height: 35px;'">
                        <dd class="concessionary">
                            <span v-for="(item, index) in couponList" :key="index"
                                @click="receiveCoupon(item.coupon_type_id)" class="top-box">
                                <span class="top-titl">
                                    <!-- 满减v-if="item.type == 'reward'"  折扣v-if="item.type == 'discount'" -->
                                    <span class="ingo" v-if="item.discount > 0">满{{ item.at_least }}享{{ item.discount
                                        }}折</span>
                                    <span class="ingo" v-if="item.money > 0">满{{ item.at_least }}减{{ item.money }}</span>
                                    <i class="i-1" v-if="item.discount > 0">满{{ item.at_least }}享{{ item.discount }}折</i>
                                    <i class="i-1" v-if="item.money > 0">满{{ item.at_least }}减{{ item.money }}</i>
                                </span>

                                <span class="top-lable" v-if="item.is_lingqu">{{ item.is_lingqu ? '已领取' : '领取' }}</span>
                            </span>
                        </dd>
                        <i class="examine" @click="ondiscounts" v-if="couponList.length > 3">查看更多</i>
                    </div>
                </dl>
            </template>
            <div style="width: 800px;padding: 12px 0;">
                <el-descriptions :column="2" :size="'medium'" :border="true">
                    <template v-for="item in returnShopClass()">
                        <el-descriptions-item labelStyle="width: 100px;" :span="item.value.length>30?2:1">
                            <template slot="label">{{ item.name }}</template>
                            {{ item.value }}
                        </el-descriptions-item>
                    </template>
                </el-descriptions>
            </div>
            <dl v-if="member.employeeid && false">
                <dt>开票员：</dt>
                <dd>
                    <span>{{ member.employeename +" "+ member.employee_mobile }}</span>
                    <span class="red_text" @click="$util.copy((member.employeename +''+ member.employee_mobile))">复制</span>
                </dd>
            </dl>
            <template v-if="goodsSkuDetail.join_manjian>0">
                <div class="mdoleDome-jian" v-if="manjian.manjian_name">
                    <dt>满减活动</dt>
                    <dd>
                        <el-popover placement="top-start" title="满额活动" width="400" trigger="hover">
                            <div>
                                <template v-if="manjian.rule_json">
                                    <template v-for="(item,index) in returnArray(manjian.rule_json)">
                                        <p>{{ returnManjianText(item) }}</p>
                                    </template>
                                </template>
                                <template v-else>
                                    <p>当前暂无配置的满减活动</p>
                                </template>
                            </div>
                            <template slot="reference">
                                <i style="cursor: default;">{{ manjian.manjian_name }}</i>
                            </template>
                        </el-popover>
                    </dd>
                </div>
                <div class="mdoleDome-discounts" v-if="manjians.length > 0">
                    <dt>满减</dt>
                    <span class="preferential" v-for="(item, index) in manjians" :key="index">{{ item }}</span>
                </div>
                <div class="mdoleDome-discounts" v-if="manjian.mansong != undefined">
                    <dt>满送</dt>
                    <dd>
                        <span style="border-radius:0px">{{ manjian.mansong }}</span>
                    </dd>
                </div>
            </template>
            <dl class="mdoleDome-goods_attr_format" v-if="goodsSkuDetail.is_virtual == 0">
                <dt>运费</dt>
                <dd>
                    <el-popover placement="top-start" title="包邮信息" width="400" trigger="hover">
                        <div>
                            <template v-if="goodsSkuDetail.freeshipping">
                                <template v-for="(item,index) in goodsSkuDetail.freeshipping">
                                    <p>订单金额达到{{ item.price }}元，即可参加“{{ item.name }}”活动享受快递免邮</p>
                                </template>
                            </template>
                            <template v-else>
                                <p>当前暂无配置的运费信息</p>
                            </template>
                        </div>
                         <template slot="reference">
                            <i style="cursor: default;" class="i-activity-flag ns-text-color ns-border-color bina" v-if="goodsSkuDetail.is_free_shipping">快递免邮</i>
                            <i style="cursor: default;" class="i-activity-flag ns-text-color ns-border-color bina" v-else>快递不免邮</i>
                         </template>
                    </el-popover>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    props: {
        manjian: {
            type: Object,
            default: () => { }
        },
        couponList: {
            type: Array,
            default: () => []
        },
        goodsSkuDetail: {
            type: Object,
            default: () => { }
        },
        manjians: {
            type: Array,
            default: () => []
        },
        activeinfo:{
            type:Object,
            default:()=>{}
        }
    },
    data: () => {
        return {
            showDome: false,
            isdiscounts: false,
            couponBtnSwitch: false
        }
    },
    computed: {
        ...mapGetters(["token","member", "siteInfo", "defaultHeadImage", "defaultShopImage", "defaultGoodsImage", "addonIsExit", "locationRegion", "storeWithoutAuthority"])
    },
    methods: {
        showoclik() {
            this.showDome = !this.showDome
        },
        ondiscounts() {
            this.isdiscounts = !this.isdiscounts
        },
        receiveCoupon(id) {
            this.$emit('receiveCoupon', id)
        },
        returnShopClass(){
            if(!this.goodsSkuDetail){
                return [];
            }
                let arr  = this.goodsSkuDetail.goods_attr_show;
                return arr;
            },
            // 将对象转变为数组
        returnArray(obj){
            let arr = [];
            for(let key in obj){
                arr.push(obj[key]);
            }
            return arr;
        },
        returnManjianText(item){
            let arr = [];
            arr.push(`订单满${item.limit}元`);
            if(item.discount_ratio){
                arr.push(`享${item.discount_ratio}折`)
            }
            if(item.discount_money){
                arr.push(`减${item.discount_money}元`)
            }
            if(item.discount_money_stacking){
                arr.push(`每满${item.limit}元减${item.discount_money_stacking}元`)
            }
            if(item.free_shipping){
                arr.push(`快递免邮`)
            }
            if(item.point){
                arr.push(`送${item.point}积分`)
            }
            if(item.coupon){
                for(let i = 0; i < item.coupon_data.length; i++){
                    let str = '';
                    if(parseFloat(item.coupon_data[i].money) > 0){
                        str = `满${item.coupon_data[i].at_least}元减${item.coupon_data[i].money}元`
                    }
                    if(parseFloat(item.coupon_data[i].discount) > 0){
                        str = `满${item.coupon_data[i].at_least}元享${item.coupon_data[i].discount}折`
                    }
                    arr.push(`送${item.coupon_num[i]}张${str}优惠券`)
                }
            }
            return arr.join('，');
        }
    }
}
</script>

<style lang="scss" scoped>
.red_text{
	color: #ff547b !important;
	cursor: pointer;
    margin-left: 6px;
}
.mdoleDome-box {
    // position: relative;
    padding: 0px 20px 10px 16px;
    // overflow: hidden;
    display: flex;

    .mdoleDome {
        width: 440px;

        dt {
            display: inline-block;
            min-width: 65px;
            height: 35px;
            line-height: 35px;
            text-align-last: justify;
            font-size: 12px;
            margin-right: 16px;
            flex-shrink: 0;
            color: #303133ad;
        }

        dd {
            display: inline-block;
            vertical-align: bottom;
            line-height: 35px;
            color: #222222;
            font-size: 12px;
            .bina {
                border: 1px solid #FB3E5E;
                padding: 2px 5px;
                border-radius: 3px;

            }
        }

        &-top {
            display: flex;
            overflow: hidden;
             margin-top: 15px;
            .show-box {
                padding-top: 5px;
                width: 275px;
                position: relative;
            .concessionary{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
            }
                .top-box {
                    position: relative;
                    line-height: 44px;

                    .top-lable {
                        position: absolute;
                        right: 11px;
                        top: -5px;
                        font-size: 10px;
                        background: rgba(255, 84, 123, 0.5490196078);
                        line-height: 15px;
                        padding: 0px 5px 0px 5px;
                        color: #fff;
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                        font-weight: 500;
                    }
                }
            }

            .examine {
                position: absolute;
                top: 4px;
                right: -70px;
                padding: 0px 10px;
                font-size: 11px;
                background: rgb(251 62 94 / 49%);
                ;
                border-radius: 3px;
                border: 2px solid #ff547b;
                color: #fff;
                cursor: pointer;

                &:hover {
                    background: rgb(251 62 94 / 62%);
                }
            }

            .top-titl {
                position: relative;
                line-height: 35px;
                cursor: pointer;

                .ingo {
                    width: 100px;
                    padding: 5px 15px;
                    font-size: 12px;
                    margin-right: 10px;
                    cursor: pointer;
                    background-color: #ff547b;
                    -webkit-mask-box-image: url("../../../assets/images/goods/coupon.png");
                }

                .i-1 {
                    position: absolute;
                    color: #ff547b;
                    left: 10px;
                    top: -9px;
                }
            }
        }

        &-jian {
            span {
                padding: 2px 5px;
                border-radius: 4px;
                color: #ff547b;
                border: 1px solid #ff547b;
            }

            &-yuan {
                display: flex;
            }


        }

        &-discounts {
            span {
                margin-right: 10px;
                border-radius: 5px;
                display: inline-block;
                padding: 0px 5px;
                background: #ff547b;
                color: #fff;
            }

        }

        &-location {
            position: absolute;
            right: 50px;
            bottom: 0;
        }
    }

    .mdoleDome-rigt {
        padding-top: 15px;
        dt {
            display: inline-block;
            min-width: 65px;
            height: 35px;
            line-height: 35px;
            text-align-last: justify;
            font-size: 12px;
            margin-right: 16px;
            flex-shrink: 0;
            color: #303133ad;
        }

        dd {
            display: inline-block;
            vertical-align: bottom;
            line-height: 35px;
            color: #222222 ;
            font-size: 12px;
        }
    }

}
</style>
